import React, { useEffect, useState, useCallback } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
// import DatePickerWithFloatingLabel from 'components/inputs/DatePickerWithFloatingLabel';
// import { AiOutlineDownload } from 'react-icons/ai';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { APP_USER_DETAILS_LIST } from 'actions/dataReport';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { roundOfDigit, startsWith } from 'components/common/utils';
// import DropDown from 'components/inputs/DropDown';
// import { AiFillCaretDown } from 'react-icons/ai';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { IoSearchOutline } from 'react-icons/io5';
import { BsDownload } from 'react-icons/bs';
import DateTimePicker from 'components/inputs/DateTimePicker';
import { BiSort } from 'react-icons/bi';
// import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

const AppUserDetailsList = () => {
  const dispatch = useDispatch();
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [searchText, setSearchText] = useState('');
  const [showSearchBar, setShowSearchBar] = useState(false);
  // const [fieldValue, setFieldValue] = useState('All');
  const [allAppUserDetailsListData, setAllAppUserDetailsListData] = useState([]);
  // const [selectedDeviceOptions, setSelectedDeviceOptions] = useState([]);
  const [startDate, setStartDate] = useState(moment(new Date()).startOf('day'));
  const [endDate, setEndDate] = useState(moment(new Date()).endOf('day'));
  const allAppUserDetailsList = useSelector((state) => state.appUserDetailsList.appUserDetailsLists);

  // const deviceFilter = [
  //   { label: 'All', value: 'All' },
  //   { label: 'Android', value: 'android' },
  //   { label: 'IOS', value: 'ios' },
  // ];

  const appUserDetailsList = useCallback(
    (value) => {
      const data = {
        ...value,
        from: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
        to: moment(endDate).format('YYYY-MM-DD HH:mm:ss'),
      };
      dispatch({ type: APP_USER_DETAILS_LIST, payload: data });
    },
    [startDate, endDate]
  );

  useEffect(() => {
    setAllAppUserDetailsListData(
      _.filter(
        allAppUserDetailsList,
        (item) =>
          startsWith(_.get(item, 'name'), searchText) ||
          startsWith(_.get(item, 'email'), searchText) ||
          startsWith(_.get(item, 'phone').toString(), searchText) ||
          startsWith(roundOfDigit(_.get(item, 'wallet_balance'), 2).toString(), searchText) ||
          startsWith(_.get(item, 'vehicles').length.toString(), searchText)
      )
    );
  }, [searchText, allAppUserDetailsList]);

  const searchHandler = (event) => {
    const value = event.target.value;
    setSearchText(value);
  };

  useEffect(() => {
    appUserDetailsList();
  }, []);

  // function getDropdownButtonLabel({ placeholderButtonLabel }) {
  //   return `${placeholderButtonLabel}`;
  // }

  // function onChange(value, event) {
  //   if (event.action === 'select-option' && event.option.value === 'All') {
  //     this.setState(this.options);
  //   } else if (event.action === 'deselect-option' && event.option.value === 'All') {
  //     this.setState([]);
  //   } else if (event.action === 'deselect-option') {
  //     this.setState(value.filter((o) => o.value !== 'All'));
  //   }
  //   // else if (value.length === this.options.length - 1) {
  //   //   this.setState(this.options);
  //   // }
  //   else {
  //     this.setState(value);
  //   }
  // }

  const dateFilter = useCallback(() => {
    if (sortByItem.item && sortByItem.order) {
      const filterDateData = {
        from: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
        to: moment(endDate).format('YYYY-MM-DD HH:mm:ss'),
      };
      getSortByItem(sortByItem.item, sortByItem.order, '', filterDateData);
    } else {
      const filterDateData = {
        from: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
        to: moment(endDate).format('YYYY-MM-DD HH:mm:ss'),
      };
      appUserDetailsList(filterDateData);
    }
  }, [startDate, endDate, sortByItem]);

  // const filterData = [
  //   { label: 'Newest', value: 'Newest' },
  //   { label: 'Oldest', value: 'Oldest' },
  //   { label: 'All', value: 'All' },
  // ];

  // useEffect(() => {
  //   const newestData = {
  //     sortBy: '1',
  //     device: _.map(selectedDeviceOptions, (item) => item.value),
  //   };
  //   fieldValue === 'Newest' && appUserDetailsList(newestData);
  //   const oldestData = {
  //     sortBy: '-1',
  //     device: _.map(selectedDeviceOptions, (item) => item.value),
  //   };
  //   fieldValue === 'Oldest' && appUserDetailsList(oldestData);
  //   const data = {
  //     device: _.map(selectedDeviceOptions, (item) => item.value),
  //   };
  //   fieldValue === 'All' && appUserDetailsList(data);
  // }, [fieldValue, selectedDeviceOptions]);

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page,
      };
      appUserDetailsList(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      appUserDetailsList(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const search = <SearchBox preIcon={<BsSearch />} value={searchText} onChange={searchHandler} />;
  const searchIcon = <IoSearchOutline size={27} onClick={() => setShowSearchBar(true)} className="report-search-icon" />;

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="App User Details List" />
        <div className="page-content-wrapper scrollable">
          <div className="data-report--main">
            <Card>
              <div className="data-report__inner">
                <div className="data-report__box">
                  <Row className="data-report__row">
                    <Col
                      xl={`${showSearchBar ? 2 : 1}`}
                      md={`${showSearchBar ? 12 : 2}`}
                      className={`${showSearchBar ? '' : 'data-report-search-box'}`}
                    >
                      {showSearchBar ? search : searchIcon}
                    </Col>
                    {/* <Col xl={2} md={4}>
                      <DropDown
                        popupClass="main-menu bottom scrollable"
                        trigger={
                          <>
                            <div className="log-filter-block">
                              <div className="log-filter-icon">
                                <BsFilter />
                                <span className="log-filter-label">{fieldValue}</span>
                              </div>
                              <div className="log-arrow__icon">
                                <AiFillCaretDown />
                              </div>
                            </div>
                          </>
                        }
                        triggerClass="log-filter-dropdown"
                      >
                        {_.map(filterData, (item, index) => (
                          <ul key={`${index}`}>
                            <li
                              className="item"
                              onClick={() => {
                                setFieldValue(item.value);
                              }}
                            >
                              {item.label}
                            </li>
                          </ul>
                        ))}
                      </DropDown>
                    </Col> */}
                    {/* <Col xl={2} md={4}>
                      <ReactMultiSelectCheckboxes
                        options={deviceFilter}
                        placeholderButtonLabel="Select Station"
                        getDropdownButtonLabel={getDropdownButtonLabel}
                        value={selectedDeviceOptions}
                        onChange={onChange}
                        setState={setSelectedDeviceOptions}
                        hideSearch={true}
                      />
                    </Col> */}
                    <Col xl={`${showSearchBar ? 6 : 7}`} md={`${showSearchBar ? 10 : 10}`}>
                      <div className="data-report-date_picker">
                        {/* <DatePickerWithFloatingLabel
                          defaultValueOfStartDate={new Date()}
                          defaultValueOfEndDate={new Date()}
                          onChangeOfStartDate={(item) => setStartDate(item)}
                          onChangeOfEndDate={(item) => setEndDate(item)}
                        /> */}
                        <DateTimePicker
                          onChangeOfStartDate={(item) => setStartDate(item)}
                          onChangeOfEndDate={(item) => setEndDate(item)}
                          initialValueOfStartDate={moment(new Date()).startOf('day')}
                          initialValueOfEndDate={moment(new Date()).endOf('day')}
                        />
                      </div>
                    </Col>
                    <Col xl={1} md={2}>
                      <div className="report-search-box" onClick={dateFilter}>
                        <Button className="report-search-button">Search</Button>
                      </div>
                    </Col>
                    <Col xl={2} md={4}>
                      <div className="report-search-excel-block">
                        <div className="advance-filter-btn">
                          <Button className="report-search-button">Advance Filter</Button>
                        </div>
                      </div>
                    </Col>
                    <Col xl={1} md={1} className="excel-icon--block">
                      <div className="report-excel-icon">
                        <BsDownload size={28} color={'#3c7cdd'} />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="data-report__table">
                  <div className="table-responsive">
                    <table className="record-list-table" id="table-to-xls">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>Sr No.</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Name</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Mobile Number</span>
                              <span className="ico" onClick={() => handleSorting('phone', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Email Id</span>
                              <span className="ico" onClick={() => handleSorting('email', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Android / iOS</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Wallet Balance</span>
                              <span className="ico" onClick={() => handleSorting('wallet_balance', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Total Vehicle</span>
                              <span className="ico" onClick={() => handleSorting('vehicles', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {_.isEmpty(allAppUserDetailsListData) ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="empty-data-block">No App User Details List Found</div>
                            </td>
                          </tr>
                        ) : (
                          _.map(allAppUserDetailsListData, (item, key) => {
                            return (
                              <>
                                <tr key={`app-user-details-list-${key}`}>
                                  <td>{key + 1}</td>
                                  <td>{_.get(item, 'name', 'Guest User')}</td>
                                  <td>{_.get(item, 'phone', '')}</td>
                                  <td>{_.get(item, 'email', '')}</td>
                                  <td>{item.androidToken && item.iosToken ? 2 : item.androidToken || item.iosToken ? 1 : 0}</td>
                                  <td>{roundOfDigit(_.get(item, 'wallet_balance', ''), 2)}</td>
                                  <td>{_.get(item, 'vehicles', '').length}</td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </LayoutContainer>
    </>
  );
};

export default AppUserDetailsList;
